<ion-content class="ion-padding">
  <div class="modal-content">
    <div class="content">
      <smatchy-title mode="start">{{ titleKey | translate }}</smatchy-title>

      <p class="description">
        {{ descriptionKey | translate }}
      </p>

      @if (!isOsUnavailableMode) {
      <p class="description privacy-description">
        {{ 'LOCATION_PERMISSION_MODAL.PRIVACY_DESCRIPTION' | translate }}
      </p>
      }

      <div class="illustration-card">
        <img src="assets/images/access_user_nearby.png" alt="Nearby users illustration" />
      </div>
    </div>

    <div class="actions">
      <ion-button expand="block" class="primary-action" (click)="enableLocation()" [disabled]="isLoading">
        @if (isLoading) {
        <ion-spinner name="crescent"></ion-spinner>
        } @else {
        {{ primaryButtonKey | translate }}
        }
      </ion-button>
      <ion-button expand="block" fill="outline" class="secondary-action" (click)="dismiss()" [disabled]="isLoading">
        {{ 'LOCATION_PERMISSION_MODAL.LATER' | translate }}
      </ion-button>
    </div>
  </div>
</ion-content>
